import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { userQuery } from '@amfam/shared/user';
import { CopyService } from '@amfam/shared/utility/shared-services';
import { ConfirmationModel } from '@amfam/ui-kit';

@Component({
  selector: 'ds-kyd-unenroll-all-confirmation',
  templateUrl: 'kyd-partial-household-unenroll-confirmation.component.html',
  standalone: false
})
export class PartialHouseholdUnenrollConfirmationComponent implements OnInit {
  public confirmationData$: Observable<ConfirmationModel>;
  public customerEmail$: Observable<string>;
  constructor(
    private store: Store,
    private copyService: CopyService
  ) {}

  ngOnInit() {
    this.confirmationData$ = combineLatest([
      this.store.select(userQuery.selectPrimaryEmail),
      this.store.select(userQuery.selectMyAccountEmail)
    ]).pipe(
      map(([primaryEmail, myAccountEmail]) => primaryEmail || myAccountEmail),
      filter(email => !!email),
      map(email => this.getConfirmationData(email.emailAddress))
    );
  }

  private getConfirmationData(emailAddress: string) {
    return {
      confirmation: {
        heading: this.copyService.getCopy('kydSmartphonePhh.kydUnenrollAllConfirmationHeader'),
        infoText: this.copyService.getCopy('kydSmartphonePhh.unenrollAllConfirmationContent', {
          emailId: emailAddress
        })
      }
    };
  }
}
